import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcDialog = _resolveComponent("NcDialog")!

  return (_openBlock(), _createBlock(_component_NcDialog, {
    name: _ctx.title,
    message: _ctx.message,
    buttons: _ctx.buttons,
    onClosing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close(null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NcTextField, {
        ref: "input",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        label: _ctx.label,
        type: _ctx.password ? 'password' : 'text',
        onKeydown: _withKeys(_ctx.submit, ["enter"])
      }, null, 8, ["modelValue", "label", "type", "onKeydown"])
    ]),
    _: 1
  }, 8, ["name", "message", "buttons"]))
}